import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import type { PrivateHire } from "@/lib/coach-manager/types";
import { PrivateHireDetail } from "./PrivateHireDetail";

interface PrivateHireDetailDrawerProps {
  privateHire: PrivateHire | null;
  onClose: () => void;
}

/**
 * Wide right-side drawer hosting the full `PrivateHireDetail` for whichever
 * PrivateHire is selected. Mirrors `ContractDetailDrawer`, minus the
 * "Initiate Copy" action — PrivateHire search/detail is display-only (no
 * Copy Operations integration yet).
 */
export function PrivateHireDetailDrawer({ privateHire, onClose }: PrivateHireDetailDrawerProps) {
  return (
    <Sheet open={privateHire !== null} onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-[80vw]">
        <SheetHeader>
          <SheetTitle className="font-display">
            {privateHire ? `PrivateHire ${privateHire.PrivateHireID}` : "PrivateHire"}
          </SheetTitle>
          <SheetDescription>Full detail, read-only.</SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-4">
          {privateHire && (
            <PrivateHireDetail key={privateHire.PrivateHireID} privateHire={privateHire} />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
